var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"user-online-status",class:_vm.statusClass})])
}
var staticRenderFns = []

export { render, staticRenderFns }